// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconInvestmentPurchasePath = 'M22.565 6.025h-4.148v-2h7.578v7.577h-2V7.423l-8.776 8.794-2.799-2.798-7.01 6.923-1.405-1.423 8.424-8.32 2.788 2.788 7.348-7.362Zm2.482 19.95V14.803h-2v11.172h2Zm-6.012-8.38v8.38h-2v-8.38h2Zm-6 8.38V20.39h-2v5.586h2Zm-6 0v-2.793h-2v2.793h2Z';
var NavigationIconInvestmentPurchase = baseIcon('NavigationIconInvestmentPurchase', {
  getPath: () => NavigationIconInvestmentPurchasePath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconInvestmentPurchase;
//# sourceMappingURL=index.js.map